/*
JTM outside builder - scripts
- builder buttons
*/

/* START - get if svg diagram is enabled */
function usingSvgDiagramOutside() {
  // 1. Check window variable first
  if (typeof window.hasDiagramSVG !== 'undefined') {
    return !!window.hasDiagramSVG; // Converts truthy/falsy to strict boolean
  }
  // 2. Fallback to dataset if window variable is missing
  var datasetValue = document.querySelector('#fabric-picker-box')?.dataset.useSvgDiagram;
  return datasetValue === 'true';
}

document.addEventListener('DOMContentLoaded', function () {

  //console.log("loaded");
  
  ///////////////////////////////////////////
  // start - builder buttons get and set localStorage - sessionStorage
  //waitForElm('html.is-products #builder-buttons-box', true).then((elm) => {
  $q('html.is-products:not(.is-builder) #builder-buttons-box').wait(true,(elm) => {
    
    // temp remove
    /*if (sessionStorage.getItem('selectedFabric')) {
      sessionStorage.removeItem('selectedFabric');
    }
     if (localStorage.getItem('selectedFabric')) { 
      localStorage.removeItem('selectedFabric'); 
    } */
    // temp remove

    
    /* const builderBox = document.getElementById('builder-buttons-box');
    builderBox.addEventListener('click', function (e) { 

      //console.log('test');

      const anchor = e.target.closest('a.builder-link');
      if (anchor && builderBox.contains(anchor)) {

        e.preventDefault();
        
        const data = {};
        let datasetElement = anchor.dataset;

        if(anchor.classList.contains("builder-card__link")){
          datasetElement = anchor.closest('li').dataset;
        }
        for (const key in datasetElement) {
          data[key] = datasetElement[key];
        }
        setSelectedFabric(data);
        setTimeout(function(){
          // Optional: redirect after storing
          window.location.href = anchor.href;
        },350);
      }
    }); */

    // old builder buttons event handler
    const builderBoxOld = document.querySelector('#builder-buttons-box #builder-buttons-ul');
    builderBoxOld.addEventListener('click', function (e) {

      const anchor = e.target.closest('a.builder-link:not(.builder-card__link)');
      if (anchor && builderBoxOld.contains(anchor)) {

        console.debug("old builder butons clicked");

        e.preventDefault();
        
        const data = {};
        let datasetElement = anchor.dataset;
        for (const key in datasetElement) {
          data[key] = datasetElement[key];
        }
        setSelectedFabric(data);
        setTimeout(function(){
          // Optional: redirect after storing
          window.location.href = anchor.href;
        },350);
      }
    });
    
    // new builder buttons event handler
    const builderBoxNew = document.querySelector('#builder-buttons-box #builder-buttons-ul-new');
    builderBoxNew.addEventListener('click', function (e) { 

      const anchor = e.target.closest('a.builder-card__link');
      if (anchor && builderBoxNew.contains(anchor)) {

        console.debug("new builder butons clicked");

        e.preventDefault();
        
        const data = {};
        let datasetElement = anchor.closest('li').dataset;
        for (const key in datasetElement) {
          data[key] = datasetElement[key];
        }
        setSelectedFabric(data);
        setTimeout(function(){
          // Optional: redirect after storing
          window.location.href = anchor.href;
        },350);
      }
    });
  });

  // only run on builder product pages - .product-info.cd-builder-ready 
  //waitForElm('html.is-products.is-builder #cd-builder #cd-step-fabric .control [data-cd-option-name].cd-input', true).then((elm) => {
  $q('html.is-products.is-builder #cd-builder #cd-step-fabric .control [data-cd-option-name].cd-input').wait(true,(elm) => {

    const urlParams = new URLSearchParams(window.location.search);
    if (sessionStorage.getItem('selectedFabric') && document.querySelector('html.is-products.is-builder') !== null /* && urlParams.has('builder_fabric') */) {
        //waitForElm('html.is-products.is-builder #cd-builder #cd-step-fabric #cd-fabric-picker--box', true).then((elm) => {
          if(!urlParams.has('productBuilderKey')){            
            getSelectedFabricPopulateFields();            
          }
        //});
    }    
  });



  function splitCamelCase(str) {
    return str.replace(/([A-Z])/g, '-$1').toLowerCase();
  }

  function toCamelCase(str) {
    return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
  }

  // Store selected fabric data in sessionStorage - localStorage
  function setSelectedFabric(data) {    
    sessionStorage.setItem('selectedFabric', JSON.stringify(data));
  }

  // Get selected fabric data from sessionStorage - localStorage
  function getSelectedFabric() {    
    const stored = sessionStorage.getItem('selectedFabric');
    return stored ? JSON.parse(stored) : null;
  }
  
  // Define which fields you want to populate (must match input[name] attributes)
  const fabricFields = ['fabric-width', 'fabric-design', 'fabric-price', 'fabric-name-sku', 'fabric-image-url'];
  /*, 'welt-width', 'welt-fabric-design', 'welt-price', 'welt-name-sku', 'welt-image-url' */

  function capitalizeWordsString(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }
  
  // Get selected fabric data and populate form fields from sessionStorage - localStorage
  function getSelectedFabricPopulateFields() {

    //console.log('getSelectedFabricPopulateFields()');
    //console.debug('set builder_fabric param fabric = getSelectedFabricPopulateFields()');

    //const builderButtonText = ["fabric", "fabricWidth", "fabricDesign"];
    //const key = "fabricDesign";
    //builderButtonText.includes(storedBuilderButtonLastClicked)
    let cushionBuilderText = document.querySelector("#itoris_dynamicproductoptions").dataset.cushionBuilderText;
    const stored = sessionStorage.getItem('selectedFabric');
    const storedBuilderButtonLastClicked = sessionStorage.getItem('builderButtonLastClicked');
    //console.log('cushionBuilderText 1', cushionBuilderText);
    if(cushionBuilderText == ""){
      cushionBuilderText =  document.querySelector("#itoris_dynamicproductoptions").dataset.builderType;
      cushionBuilderText = cushionBuilderText.replace('-',' ');
      cushionBuilderText = capitalizeWordsString(cushionBuilderText);
    }
    //console.log('cushionBuilderText 2', cushionBuilderText);
    if (!stored && (storedBuilderButtonLastClicked === cushionBuilderText)) return;

    const data = JSON.parse(stored);

    /* console.debug('defaultFabric - getSelectedFabricPopulateFields()',defaultFabric);
    console.debug('defaultWeltFabric - getSelectedFabricPopulateFields()',defaultWeltFabric);
    console.debug('defaultFabricRain- getSelectedFabricPopulateFields()',defaultFabricRain);
    console.debug('defaultWeltFabricRain - getSelectedFabricPopulateFields()',defaultWeltFabricRain); */

    //console.log(data['builderButton']);
    //console.log(cushionBuilderText);

    if (data['builderButton'] !== cushionBuilderText) return;

    // DEFINE SET BUILDER BUTTON FABRIC FOR STANDARD AND RAIN FABRIC
    function setBuilderButtonFabric() {

      if (document.documentElement.classList.contains('is-builder')) {

        let cdStepFabric = document.querySelector('html.is-products.is-builder #cd-step-fabric');
        // Only loop over fields you've explicitly listed
        fabricFields.forEach(fieldName => {
          let input;
          let fieldNameCamelCase = toCamelCase(fieldName);
          if ((input = cdStepFabric.querySelector(`#cd-step-fabric input[data-cd-option-name="cd--${fieldName}"].cd-input`)) !== null && data[fieldNameCamelCase] !== undefined) {
            input.value = data[fieldNameCamelCase];
          }
        });
        
        let fabricNameSkuClean = data['fabricNameSku'];
        fabricNameSkuClean = fabricNameSkuClean.replace("Awning / Marine Fabric","");
        //fabricNameSkuClean = fabricNameSkuClean.replace("Elements Collection Upholstery Fabric","");
        //fabricNameSkuClean = fabricNameSkuClean.replace("Fusion Collection Upholstery Fabric","");
        fabricNameSkuClean = fabricNameSkuClean.replace("Upholstery Fabric","");
        fabricNameSkuClean = fabricNameSkuClean.replace("Drapery Fabric","");
        fabricNameSkuClean = fabricNameSkuClean.replace("46-Inch","");
        fabricNameSkuClean = fabricNameSkuClean.replace("60-Inch","");
        fabricNameSkuClean = fabricNameSkuClean.replace("80-Inch","");
        fabricNameSkuClean = fabricNameSkuClean.replace("54-Inch","");
        fabricNameSkuClean = fabricNameSkuClean.replace('Sunbrella by','')
        fabricNameSkuClean = fabricNameSkuClean.trim();
            
        // fabric - populate fabric picker box svg image and name label
        //if (document.querySelector('html.is-products.is-builder') !== null) {
        let fabricImageUrl;
        let fabricNameSku;
        let weltImageUrl;
        let weltNameSku;
        if ((fabricImageUrl = cdStepFabric.querySelector('.cd-fabric-picker--img-fabric svg image')) !== null) {
          fabricImageUrl.setAttribute('href', data['fabricImageUrl']);
        }
        if ((fabricNameSku = cdStepFabric.querySelector('.cd-fabric-picker--name-fabric')) !== null) {
          fabricNameSku.textContent = fabricNameSkuClean;//data['fabricNameSku'];
        }
        if ((weltImageUrl = cdStepFabric.querySelector('.cd-fabric-picker--img-welt svg image')) !== null) {
          weltImageUrl.setAttribute('href', data['fabricImageUrl']);
        }
        if ((weltNameSku = cdStepFabric.querySelector('.cd-fabric-picker--name-welt')) !== null) {
          weltNameSku.textContent = fabricNameSkuClean;
        }

        //if (typeof window.newFabricPreviewSetFP === "function") {
          //console.debug(window.newFabricPreviewSetFP);
          //window.newFabricPreviewSetFP('fab-fabric', cdStepFabric, fabricNameSkuClean, data['fabricImageUrl'], data['fabricPrice'], data['fabricWidth'], data['fabricDesign'], false);
        //}

        ///////////////////
        let tempUse = true;
        if(tempUse == true){

          ////////////////////////////////////////////
          if (document.documentElement.classList.contains('pl')) {
            let targetPath = '/products/custom-barstool-cushions-copy-test-jonny';
            if (window.location.pathname === targetPath && (cdStepFabric.querySelector('.fab-layout-wrapper.fab-fabric .fab-preview-display') !== null)) {

              ///////////////////////////////
              let str = fabricNameSkuClean;//data['fabricNameSku'];
              let match = str.match(/^(.*?)\s*\(SKU:\s*(\d+)\)/);
              let productTitle = "";
              let sku = "";
              let featuredImage = data['fabricImageUrl'];

              let design = data['fabricDesign'];
              let width = data['fabricWidth'];
              let priceCost = data['fabricPrice'];
              let productHandle = data['fabricProductHandle'];
              let warranty = data['warranty'] || '';
              let warrantyPDF = data['warrantyPdf'] || '';
              
              if (match) {
                productTitle = match[1];
                sku = match[2];
              }
              ///////////////////////////////
              // fab-fabric
              if(cdStepFabric.querySelector('.fab-layout-wrapper.fab-fabric .fab-preview-display img[data-selected-image]')){
                cdStepFabric.querySelector('.fab-layout-wrapper.fab-fabric .fab-preview-display img[data-selected-image]').setAttribute('src', featuredImage);
              }
              if(cdStepFabric.querySelector('.fab-layout-wrapper.fab-fabric .fab-preview-display [data-selected-title]')){
                cdStepFabric.querySelector('.fab-layout-wrapper.fab-fabric .fab-preview-display [data-selected-title]').textContent = productTitle.replace(/\s*\(.*?\)/, '').trim();
              }
              if(cdStepFabric.querySelector('.fab-layout-wrapper.fab-fabric .fab-preview-display [data-selected-sku]')){
                cdStepFabric.querySelector('.fab-layout-wrapper.fab-fabric .fab-preview-display [data-selected-sku]').textContent = "SKU: " + sku.trim();
              }

              if(usingSvgDiagramOutside == true){
                /////////////////////////////////////////////////////////////
                // set builder shell sidebar tab panel - fabric image
                if (window.shouldRunBuilderSidebarWork?.('cd-step-fabric')) {
                  document.querySelector('.preview-tab-panel-selected--fabric a')?.setAttribute('href', featuredImage);
                  document.querySelector('.preview-tab-panel-selected--fabric img')?.setAttribute('src', featuredImage);
                }
                /////////////////////////////////////////////////////////////
              }

              let layoutWrapperFabFabric = document.querySelector('.fab-layout-wrapper.fab-fabric');
              if(layoutWrapperFabFabric){
                layoutWrapperFabFabric.setAttribute('data-fabric-name', productTitle.replace(/\s*\(.*?\)/, '').trim());
                layoutWrapperFabFabric.setAttribute('data-fabric-sku', sku.trim());
                layoutWrapperFabFabric.setAttribute('data-fabric-design', design);
                layoutWrapperFabFabric.setAttribute('data-fabric-width', width);
                layoutWrapperFabFabric.setAttribute('data-fabric-price', priceCost);
                layoutWrapperFabFabric.setAttribute('data-featured-image', featuredImage);
                layoutWrapperFabFabric.setAttribute('data-product-handle', productHandle);
                layoutWrapperFabFabric.setAttribute('data-warranty', warranty);
                layoutWrapperFabFabric.setAttribute('data-warranty-pdf', warrantyPDF);

                if(warranty != '' && warrantyPDF != '' && typeof warrantyPDF != 'undefined') {
                  if(warrantyPDF?.toLowerCase().indexOf('sunbrella') != -1){
                    layoutWrapper.classList.remove('no-warranty');
                    let layoutWrapperParent = layoutWrapperFabFabric.parentElement;
                    layoutWrapperParent.querySelector('.fabric-warranty__title').textContent = warranty;
                    layoutWrapperParent.querySelector('.fabric-warranty__link').setAttribute('href',warrantyPDF);
                  }
                } else {
                  layoutWrapper.classList.add('no-warranty');
                }
              }

              ///////////////////////////////
              // fab-welt
              if(cdStepFabric.querySelector('.fab-layout-wrapper.fab-welt .fab-preview-display img[data-selected-image]')){
                cdStepFabric.querySelector('.fab-layout-wrapper.fab-welt .fab-preview-display img[data-selected-image]').setAttribute('src', featuredImage);
              }
              if(cdStepFabric.querySelector('.fab-layout-wrapper.fab-welt .fab-preview-display [data-selected-title]')){
                cdStepFabric.querySelector('.fab-layout-wrapper.fab-welt .fab-preview-display [data-selected-title]').textContent = productTitle.replace(/\s*\(.*?\)/, '').trim();
              }
              if(cdStepFabric.querySelector('.fab-layout-wrapper.fab-welt .fab-preview-display [data-selected-sku]')){
                cdStepFabric.querySelector('.fab-layout-wrapper.fab-welt .fab-preview-display [data-selected-sku]').textContent = "SKU: " + sku.trim();
              }

              if(usingSvgDiagramOutside == true){
                /////////////////////////////////////////////////////////////
                // set builder shell sidebar tab panel - welt image
                if (window.shouldRunBuilderSidebarWork?.('cd-step-welt')) {
                  document.querySelector('.preview-tab-panel-selected--fabric--welt a')?.setAttribute('src', featuredImage);
                  document.querySelector('.preview-tab-panel-selected--fabric--welt img')?.setAttribute('src', featuredImage);
                }
                /////////////////////////////////////////////////////////////
              }

              let layoutWrapperFabWelt = cdStepWelt.querySelector('.fab-layout-wrapper.fab-welt');
              if(layoutWrapperFabWelt){
                layoutWrapperFabWelt.setAttribute('data-fabric-name', productTitle.replace(/\s*\(.*?\)/, '').trim());
                layoutWrapperFabWelt.setAttribute('data-fabric-sku', sku.trim());
                layoutWrapperFabWelt.setAttribute('data-fabric-design', design);
                layoutWrapperFabWelt.setAttribute('data-fabric-width', width);
                layoutWrapperFabWelt.setAttribute('data-fabric-price', priceCost);
                layoutWrapperFabWelt.setAttribute('data-featured-image', featuredImage);
                layoutWrapperFabWelt.setAttribute('data-product-handle', productHandle);
                layoutWrapperFabFabric.setAttribute('data-warranty', warranty);
                layoutWrapperFabFabric.setAttribute('data-warranty-pdf', warrantyPDF);

                if(warranty != '' && warrantyPDF != '') {
                  if(warrantyPDF.toLowerCase().indexOf('sunbrella') != -1){
                    layoutWrapper.classList.remove('no-warranty');
                    let layoutWrapperParent = layoutWrapperFabWelt.parentElement;
                    if(warranty != ''){
                      layoutWrapperParent.querySelector('.fabric-warranty__title').textContent = warranty;
                    }
                    if(warrantyPDF != ''){
                      layoutWrapperParent.querySelector('.fabric-warranty__link').setAttribute('href',warrantyPDF);
                    }
                  }
                } else {
                  layoutWrapper.classList.add('no-warranty');
                }
              }
            }
          }
          ////////////////////////////////////////////

          //window.defaultFabric
          //window.defaultWeltFabric
          //window.defaultFabricRain
          //window.defaultWeltFabricRain

          // default set fabric and welt fabric
          let defaultImageWidth = '&width=600';
          if (window.innerWidth > 768) {
            defaultImageWidth = '&width=1000';
          } else if (window.innerWidth < 400) {
            defaultImageWidth = '&width=400';
          }

          let str = data['fabricNameSku'];
          let match = str.match(/^(.*?)\s*\(SKU:\s*(\d+)\)/);
          let productTitle = "";
          let sku = "";
          if (match) {
            productTitle = match[1];
            sku = match[2];
          }

          if(data['fabricNameSku'].toLowerCase().indexOf('rain') == -1) {

            window.lastSelectedFabric = {
                  defaultCushionFabricWidth: data['fabricWidth'],
                  defaultCushionFabricDesign: data['fabricDesign'],
                  defaultCushionFabricPrice: data['fabricPrice'],
                  defaultCushionFabricNameSKU: data['fabricNameSku'],
                  defaultCushionFabricNameSKUno: productTitle.replace(/\s*\(.*?\)/, '').trim(),
                  defaultCushionFabricImageURL: data['fabricImageUrl'] + defaultImageWidth,
                  defaultCushionFabricProductHandle: data['fabricProductHandle'],
                  defaultCushionFabricWarranty: data['warranty'],
                  defaultCushionFabricWarranty: data['warrantyPdf']

            };
            window.lastSelectedWeltFabric  = {
                  defaultCushionWeltFabricWidth:  data['fabricWidth'],
                  defaultCushionWeltFabricDesign: data['fabricDesign'],
                  defaultCushionWeltFabricPrice: data['fabricPrice'],
                  defaultCushionWeltFabricNameSKU:  data['weltNameSku'],
                  defaultCushionWeltFabricNameSKUno: productTitle.replace(/\s*\(.*?\)/, '').trim(),
                  defaultCushionWeltFabricImageURL: data['fabricImageUrl'] + defaultImageWidth,
                  defaultCushionWeltFabricProductHandle: data['fabricProductHandle'],
                  defaultCushionWeltFabricWarranty: data['warranty'],
                  defaultCushionWeltFabricWarranty: data['warrantyPdf']
            };

          } else if(data['fabricNameSku'].toLowerCase().indexOf('rain') != -1) {

            //console.debug("coming from rain product");

            /*
            // set default fabric to default fabric
            window.lastSelectedFabric = window.defaultFabric;
            //console.debug('window.lastSelectedFabric',window.lastSelectedFabric);

            // set default welt fabric to default welt fabric
            if (window.isCushionBuilder == true || window.isPillowBuilder == true) {          
              window.lastSelectedWeltFabric = window.defaultWeltFabric;
              //console.debug('window.lastSelectedWeltFabric',window.lastSelectedWeltFabric);
            }
            */        

            // set rain default to sessionStorage
            window.lastSelectedFabricRain = {
                defaultCushionFabricWidth: data['fabricWidth'],
                defaultCushionFabricDesign: data['fabricDesign'],
                defaultCushionFabricPrice: data['fabricPrice'],
                defaultCushionFabricNameSKU: data['fabricNameSku'],
                defaultCushionFabricNameSKUno: productTitle.replace(/\s*\(.*?\)/, '').trim(),
                defaultCushionFabricImageURL: data['fabricImageUrl'] + defaultImageWidth,
                defaultCushionFabricProductHandle: data['fabricProductHandle'],
                defaultCushionFabricWarranty: data['warranty'],
                defaultCushionFabricWarranty: data['warrantyPdf']
            };
            /* window.lastSelectedWeltFabricRain = {
                defaultCushionWeltFabricWidth: data['fabricWidth'],
                defaultCushionWeltFabricDesign: data['fabricDesign'],
                defaultCushionWeltFabricPrice: data['fabricPrice'],
                defaultCushionWeltFabricNameSKU: data['fabricNameSku'],
                defaultCushionWeltFabricNameSKUno: productTitle.replace(/\s*\(.*?\)/, '').trim(),
                defaultCushionWeltFabricImageURL: data['fabricImageUrl'] + defaultImageWidth,
                defaultCushionWeltFabricProductHandle: data['fabricProductHandle'],
                defaultCushionFabricWarranty: data['warranty'],
                defaultCushionFabricWarranty: data['warrantyPdf']
            }; */
          }

        } // end use temp
        ///////////////////


        ////////////////////////////////////////////////////////////////////////////////////////////
        // is rain fabric - set defualt fabric and default welt fabric to default original fabric
        if(data['fabricNameSku'].toLowerCase().indexOf('rain') != -1) {

          //console.debug("coming from rain product");

          // set default fabric to default fabric
          window.lastSelectedFabric = window.defaultFabric;
          //console.debug('window.lastSelectedFabric',window.lastSelectedFabric);

          // set default welt fabric to default welt fabric
          if (window.isCushionBuilder == true || window.isPillowBuilder == true) {          
            window.lastSelectedWeltFabric = window.defaultFabric;
            //console.debug('window.lastSelectedWeltFabric',window.lastSelectedWeltFabric);
          } 
        }

      } // ends if is-builder page

      ////////////////////////////////////////////      
    }

    if(data['fabricNameSku'].toLowerCase().indexOf('rain') != -1) {
      
        //waitForElm('#cd-step-fabric [data-cd-option-name="cd--fabric-selection-sunbrella-rain"]', true).then((elm) => {
        $q('html.is-builder .product-info.cd-builder-ready #cd-step-fabric [data-cd-option-name="cd--fabric-selection-sunbrella-rain"]').wait(true,(elm) => {

          // if RAIN

          // auto select rain fabric selector
          document.querySelector('#cd-step-fabric [data-cd-option-name="cd--fabric-selection-sunbrella-rain"]').click();
          //console.log("is RAIN selectedFabric",stored);

          setBuilderButtonFabric();            
        });

    } else {

      // if not RAIN

      setBuilderButtonFabric();
    }    
    
   // }
    return data;
  }

  const fnRef = window.getSelectedFabricPopulateFields = getSelectedFabricPopulateFields;

  // Remove selected fabric from sessionStorage - localStorage
  function clearSelectedFabric() {    
    sessionStorage.removeItem('selectedFabric');
  }
  
  // end - builder buttons get and set localStorage - sessionStorage
  ///////////////////////////////////////////


});